
  import { Component, Vue } from "vue-property-decorator";

  @Component({
    name: "Carousel"
  })
  export default class Carousel extends Vue {
    publicPath: string = process.env.BASE_URL as string;
    // set right image path
    getImagePath(path: string) {
      return `${this.publicPath}${path}`;
    }

    trackClickVetRequiter() {
      this.$ua.trackEvent("Banner", "Click", "VetRecruiter");
    }
  }
